import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13 9H2V7h10zm-2 8h11v-2H12zM22 7v2h-2.18A2.99 2.99 0 0 1 17 11c-1.65 0-3-1.35-3-3s1.35-3 3-3c1.3 0 2.4.84 2.82 2zm-4 1c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1m-8 8c0 1.65-1.35 3-3 3-1.3 0-2.4-.84-2.82-2H2v-2h2.18c.41-1.16 1.51-2 2.82-2 1.65 0 3 1.35 3 3m-2 0c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }